<template>
  <div>
    <div class="communication-card" :style="{
      backgroundImage: `linear-gradient(180deg, ${list.name == '开源社区' || list.name == '资源中心'
        ? '#0F71E2'
        : '#03A2FF'
        } 30%, rgba(255,255,255,0.34) 100%),url(${list.url})`
    }">
      <div class="card-header">
        <img src="@/assets/images/website/home/jl2.png" alt="" />
        {{ list.name }}
      </div>
      <div class="card-desc">
        {{ list.desc }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>
.communication-card {
  width: 240px;
  height: 500px;
  box-sizing: border-box;
  padding: 25px;
  background: linear-gradient(180deg,
      #03a2ff 0%,
      rgba(255, 255, 255, 0.34) 100%);
  background-size: cover;

  .card-header {
    display: flex;
    // justify-content: center;
    align-items: center;
    height: 20px;
    line-height: 20px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;

    img {
      height: 24px;
      width: 24px;
      margin-right: 16px;
    }
  }

  .card-desc {
    margin-top: 29px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
  }
}
</style>